// extracted by mini-css-extract-plugin
export default {"fullWidth":"Hn-z","image":"In-z","lazyLoadPicture":"Jn-z","lazyLoadSpinner":"Kn-z","lazyLoadSpin":"Ln-z","lazyLoadImage":"Mn-z","hasStyledAspectRatio":"Nn-z"};